<template>
    <b-card class="vehicle-card">
        <h5 class="d-sm-none">
            <span class="yearMake"> {{ vehicle.year }} {{ vehicle.make }} </span
            ><br />
            {{ vehicle.model }} {{ vehicle.trim }}
        </h5>
        <div class="card-img-wrapper d-flex justify-content-center">
            <vehicle-image
                :body-style="vehicle.bodyType"
                :vehicle-name="vehicleName"
                :vehicle-image-url="vehicleImageUrl"
            />
        </div>
        <div
            class="d-flex flex-column justify-content-sm-end justify-content-between"
        >
            <h5 class="d-sm-block d-none text-center">
                <span class="yearMakeModel">
                    {{ vehicle.year }} {{ vehicle.make }}
                    {{ vehicle.model }} </span
                ><br />
                {{ vehicle.trim }}
            </h5>
            <div class="d-flex justify-content-between d-sm-none">
                <price-block label="Base Price" :value="vehicle.msrp" />
                <price-block label="Options" :value="optionsCost" add-plus />
                <price-block
                    label="Total"
                    :value="vehicle.msrp + optionsCost"
                    variant="blue"
                />
            </div>
        </div>
    </b-card>
</template>

<style lang="scss">
.vehicle-card {
    background-color: $very-light-gray;
    color: $dark-gray;
    border: none;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);

    @include media-breakpoint-up(md) {
        box-shadow: none;
        background-color: #fff;
        padding-bottom: 15px;
    }
}

.card-body {
    padding: 0.7rem 1.25rem;
}

h5 {
    font-weight: normal;
    font-size: 16px;

    .yearMake {
        font-size: 10px;
        font-weight: 300;
    }

    @include media-breakpoint-up(md) {
        font-size: 16px;

        .yearMakeModel {
            font-family: $helvetica-55-Roman;
            font-size: 18px;
        }
    }
}
</style>

<script>
import api from "@/api";
import PriceBlock from "./PriceBlock";
import VehicleImage from "../../components/VehicleImage";
import _ from "lodash";

export default {
    name: "VehicleCard",

    components: {
        "price-block": PriceBlock,
        VehicleImage
    },

    props: {
        vehicle: {
            type: Object,
            required: true
        },
        optionsCost: {
            type: Number,
            required: false,
            default: 0
        },
        exteriorColorCode: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            vehicleImageUrl: null
        };
    },

    computed: {
        vehicleName() {
            return `${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model}`;
        }
    },

    watch: {
        exteriorColorCode(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.updateVehicleImageUrl();
            }
        }
    },

    mounted() {
        this.updateVehicleImageUrl();
    },

    methods: {
        updateVehicleImageUrl() {
            if (_.isNil(this.exteriorColorCode)) {
                return;
            }

            const size = window.innerWidth < 768 ? "WIDTH_320" : "WIDTH_480";

            const request = {
                type: "PROFILE",
                size,
                exteriorColorCode: this.exteriorColorCode,
                background: "WHITE"
            };

            return api
                .post(
                    `/vehicle-data/styles/${this.vehicle.styleId}/image`,
                    request
                )
                .then(response => {
                    this.vehicleImageUrl = _.get(response, "data[0].url");
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
